module.exports = __webpack_public_path__ + "img/uitleg-stemdemo.afeff15a.png";